import { apiStoreLenses } from 'root/src/client/logic/api/lenses'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'

const { viewProfileChild } = apiStoreLenses

export default (state) => {
	const recordId = currentRouteParamsRecordId(state)
	return viewProfileChild(recordId, state)
}
